import { useEffect, useState } from "react"
import { frFR as defaultLocale } from '@mui/x-date-pickers/locales/frFR';

export function useDatePickerLocales(locale: string) {
    const [results, setResults] = useState<object | null>(null);

    useEffect(() => {
        (async () => {
            const texts = await import(`@mui/x-date-pickers/locales/${locale}.js`);
            setResults(texts?.[locale]);
        })();
    }, [locale]);

    return results ?? defaultLocale;
}